import { createApp } from 'vue'
import App from './App.vue'
import store from './store/mainStore'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/global.css'

createApp(App)
    .use(store)
    .mount('#app')
